<template>
 
<div class="p-inputgroup">
    <span class="p-inputgroup-addon">配號方式</span>
    <PrimeDropdown
      v-model="value"
      :options="options"
       placeholder="選擇"
       optionLabel="name"
       optionValue="code"
      @change="onChange($event)"
      style="maxWidth:150px;width:150px;"
    />
  </div>
</template>


<script>
export default {
  props: ["modelValue"],
  emits: ["update:modelValue"],

  data() {
    return {
      options: [{ name: "1:上傳配號", code: 1 }, { name: "2:區間號", code: 2 }],
      value: null,
     };

  },
   
  created() {
     
    this.value = this.modelValue;
  },
   

  methods: {
   
    onChange() {
      this.$emit("update:modelValue", this.value);
      this.$emit("change", this.value);
    },
  },
};
</script>
